import { Datepicker } from "@ijavad805/react-datepicker";
import moment from "moment";
import TextInput from "./TextInput";
import { useEffect, useState } from "react";

interface IDatepickerProps {
  name: string;
  value?: string;
  onChange: (name: string, value: string) => void;
  label: string;
  extraLabel?: boolean;
}

const DatePicker = ({
  label,
  name,
  onChange,
  value,
  extraLabel,
}: IDatepickerProps) => {
  // useEffect(() => {
  //   onChange(name, moment(value).format("YYYY-MM-DD"));
  // }, []);
  // console.log({ value });

  return (
    <Datepicker
      footer={() => {
        return (
          <>
            <div
              onClick={() => {
                onChange(name, moment().format("YYYY-MM-DD"));
              }}
            >
              امروز
            </div>
          </>
        );
      }}
      closeWhenSelectADay
      format={"YYYY-MM-DD"}
      input={
        <TextInput
          label={label}
          name={name}
          onChange={onChange}
          extraLabel={extraLabel}
        />
      }
      value={!value ? undefined : moment(value)}
      onChange={(val: any) => onChange(name, moment(val).format("YYYY-MM-DD"))}
      lang="fa"
      theme="blue"

      // defaultValue={moment()}
    />
  );
};

export default DatePicker;
